import ReactGA from 'react-ga';

export default ({ gaTrackingCode }) => {
  console.log('GA Tracking code', gaTrackingCode);
  if (gaTrackingCode) {
    ReactGA.initialize(gaTrackingCode);
  }
};



// WEBPACK FOOTER //
// ./book/src/commons/config/initGoogleAnalytics.js